
import { LookupItem } from '../models/lookup-item';
import { ILookup } from './Ilookup';
import { IVisaType } from './visa-type';

export class Person {
  type = '';
  title: LookupItem | null = null;
  titleOther = '';
  firstName = '';
  surname = '';
  dob: Date | string = '';
  sponsorRelation = '';
  countryResidence: LookupItem | null = null;
  passportCountry: LookupItem | null = null;
  passportNumber = '';
  residenceStatus = '';
  timeResident = '';
  maritalStatus: LookupItem | null = null;
  parentRelation = '';
  timeWithParents = '';
  financialDependancy = '';
  healthCondition: string[] = [];
  applicantCrime: string[] = [];
  isSponsor = false;
  education: LookupItem | null = null;
  occupation = '';
  incapacitated = '';
  inAustralia = '';
  location: LookupItem | null = null;
  holdAustralianVisa = '';
  arriveAustralia: Date | string = '';
  visaType: IVisaType | null = null;
  visaExpire: Date | string = '';
  departAustralia: Date | string = '';
  refusedVisa: string[] = [];
  cancelledVisa: string[] = [];
  realtionToApplicant: LookupItem | null = null;

  public static ageDifference = (value: Date | string): number | null => {
    const now = new Date();
    let dob: Date;

    // Handle different input types
    if (value instanceof Date) {
      dob = value;
    } else if (typeof value === 'string') {
      // Try to parse DD-MM-YYYY format or ISO string
      if (value.includes('-') && value.length === 10) {
        const parts = value.split('-');
        if (parts.length === 3) {
          // Assume DD-MM-YYYY format
          dob = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
        } else {
          dob = new Date(value);
        }
      } else {
        dob = new Date(value);
      }
    } else {
      return null;
    }

    // Check if date is valid
    if (isNaN(dob.getTime())) {
      return null;
    }

    // Calculate age in years
    const ageInMilliseconds = now.getTime() - dob.getTime();
    const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
    
    return Math.floor(ageInYears);
  }

  public static getTitle(person: Person | null) {
    if (!person) {
      return '';
    }

    return person.title
      ? person.title.value
      : person.titleOther;
  }
}